import { type ResourceId } from '../common/structs/general';

export const cart = () => ({
    single: () => `/cart`,
    checkout: (id?: ResourceId) => `/cart/checkout${id ? '/' + id : ''}`,
    V2: () => ({
        single: (cartId: string) => ({
            cart: () => `/cart/${cartId}`,
            success: () => `/cart/${cartId}/success`,
            cancel: () => `/cart/${cartId}/cancel`,
        }),
    }),
    delete: (id: ResourceId) => `/cart/cart_items/${id}`,
    convertToDraft: () => '/cart/convert_to_draft',
});
